import React, {
  useContext,
  createContext,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import {
  getThemeContext,
  setGlobalThemeCode,
  setUrlRefCode,
  isPartnerExist,
} from "../../api";

const themeContext = createContext(undefined);

export const useTheme = () => useContext(themeContext);

function useProvideTheme() {
  const [themeData, setThemeData] = useState(null);

  const isShowPartnershipLogo = useMemo(() => {
    return themeData?.data?.code === "STOCKAL" ? false : true;
  }, [themeData?.data?.code]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Function to get the current base URL
  const getCurrentBaseUrl = () => {
    return `${window.location.protocol}//${window.location.host}`;
    // return  `https://uat-avanse.borderless.world/`
    // return  `https://fly-finance.borderless.world`
    // return "https://uat-shiftaltcap.borderless.world";
  };

  // Function to get the dynamic code from theme data
  const getThemeCode = () => {
    // Extract code from theme data, fallback to "STOCKAL" if not available
    return themeData?.data?.code || themeData?.code || "STOCKAL";
  };

  // Function to get the dynamic logo from theme data
  const getThemeLogo = () => {
    if (themeData?.data?.logo !== "logo") {
      return themeData?.data?.logo || null;
    } else {
      return null;
    }
  };

  const refCodeFromUrl = new URLSearchParams(window.location.search).get(
    "refCode",
  );

  const storedRefCode = sessionStorage.getItem("refCode");

  useEffect(() => {
    if (!refCodeFromUrl && storedRefCode) {
      setUrlRefCode(storedRefCode);
    }
  }, [refCodeFromUrl, storedRefCode]);

  // Function to call the theme context API
  const fetchThemeContext = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const baseUrl = getCurrentBaseUrl();
      const response = await getThemeContext(baseUrl);
      setThemeData(response);
      const themeCode = response?.data?.code || response?.code || "STOCKAL";
      setGlobalThemeCode(themeCode);

      if (refCodeFromUrl) {
        const partnerResp = await isPartnerExist(refCodeFromUrl);

        if (partnerResp?.data?.partnerExist === true) {
          setUrlRefCode(partnerResp.data.refCode);
          sessionStorage.setItem("refCode", partnerResp.data.refCode);
        }
      }
    } catch (err) {
      setError(err);
      console.error("Error fetching theme context:", err);
    } finally {
      setLoading(false);
    }
  }, [refCodeFromUrl]);

  // Call API on first render
  useEffect(() => {
    fetchThemeContext();
  }, [fetchThemeContext]); // Added fetchThemeContext to dependencies

  return {
    themeData,
    setThemeData,
    loading,
    error,
    fetchThemeContext, // Expose function to refetch if needed
    getCurrentBaseUrl,
    getThemeCode,
    getThemeLogo,
    isShowPartnershipLogo,
  };
}

export function ProvideTheme({ children }) {
  const theme = useProvideTheme();
  return (
    <themeContext.Provider value={theme}>{children}</themeContext.Provider>
  );
}
